<template lang="pug">
  div.bank-packets.uploaded-packet-create
    e-modal(
    ref="modalForm"
    @confirm="sendForm()"
    @close="closeForm()"
    :hideDeleteButton="false"
    title="Редактирование ошибки"
    :autoHeight="true"
    :showDeleteBtn="true"
    @deleteItem="deleteItem()"
    )
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
              name="billing_account"
              label="Лицевой счет"
              :model="fields"
              tabView="tab1"
              validationRule="number"
              :required="true"
              )
              e-form-group(
              name="value"
              label="Сумма операции"
              :model="fields"
              tabView="tab1"
              validationRule="double"
              :required="true"
              )
              e-form-group(
              name="dt_payment"
              label="Дата операции"
              :model="fields"
              tabView="tab1"
              inputType="calendar"
              type="datetime"
              format="dd.MM.yyyy HH:mm:ss"
              valueFormat="yyyy-MM-dd HH:mm:ss"
              )
              e-form-group(
              name="number"
              label="Номер платежного поручения"
              :model="fields"
              tabView="tab1"
              :required="true"
              )
              e-form-group(
              name="period"
              label="Период оплаты"
              :model="fields"
              tabView="tab1"
              inputType="calendar"
              type="month"
              format="MM/yyyy"
              valueFormat="yyyy-MM"
              :required="true"
              )



</template>

<script>
  import packetErrorForm from './mixins/packet-error-form'
  import {bankPackets} from "../../api/api-endpoints"

  export default {
    mixins: [packetErrorForm],
    methods: {
      closeForm () {
        this.$refs.modalForm.redirectToPrev()
      },
      getItemEndpoint (route) {
        return bankPackets.unsortedPacketError(
          route.params.packetId,
          route.params.id
        )
      },
      getUpdateOrCreateUrl () {
        return bankPackets.unsortedPacketErrorUpdate(
          this.$route.params.packetId,
          this.$route.params.id
        )
      },
      getDeleteUrl (fieldId) {
        return bankPackets.unsortedPacketErrorDelete(
          this.$route.params.packetId,
          fieldId
        )
      }
    }
  }
</script>
